/* import __COLOCATED_TEMPLATE__ from './phone-number-flag-icon.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();